import { render, staticRenderFns } from "./TransactionDetailTable.vue?vue&type=template&id=2082e53a"
import script from "./TransactionDetailTable.vue?vue&type=script&lang=js"
export * from "./TransactionDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports